/**
 *
 * NewTreatmentLoading
 *
 */

import LoadingScreen from "basicComponents/LoadingScreen/LoadingScreen";
import styled from "styled-components";

function NewTreatmentLoading(props) {
  return <Screen {...props} />;
}

NewTreatmentLoading.propTypes = {
  ...LoadingScreen.propTypes,
};

NewTreatmentLoading.defaultProps = {
  ...LoadingScreen.defaultProps,
};

export default NewTreatmentLoading;

const Screen = styled(LoadingScreen)`
  height: 440px;
`;
